import React from 'react';
import {
    Table,
    TableBody,
    TableBodyCell,
    TableBodyRow,
    TableHead,
    TableHeadCell,
    TableHeadRow
} from "@tag/tag-components-react-v4";
import styles from './Info.module.scss';

const Info = () => {

    const renderKnownBugs = () => {
        return (
            <ul>
                <li>No known bugs at this time</li>
            </ul>
        )
    }

    const renderRolesInfo = () => {
        return (
            <>
                <p>
                    HSC Self Service is accessible to everyone in Access by default. Some additional roles are available
                    which enable further functionality. If you feel that you should have one or more of these roles, please contact HSC
                    DevOps with your justification.
                </p>
                <Table className={styles.customTable}>
                    <TableHead>
                        <TableHeadRow>
                            <TableHeadCell>Role Name</TableHeadCell>
                            <TableHeadCell>Role ID</TableHeadCell>
                            <TableHeadCell>AD Group (Production)</TableHeadCell>
                            <TableHeadCell>Explanation</TableHeadCell>
                        </TableHeadRow>
                    </TableHead>
                    <TableBody>
                        <TableBodyRow>
                            <TableBodyCell>Administrator</TableBodyCell>
                            <TableBodyCell>admin</TableBodyCell>
                            <TableBodyCell>sg_Users_Azure_HSC_DevOps_Platform</TableBodyCell>
                            <TableBodyCell>For devops or privileged team members, to perform third line/infra tasks.</TableBodyCell>
                        </TableBodyRow>
                        <TableBodyRow>
                            <TableBodyCell>Create Environment</TableBodyCell>
                            <TableBodyCell>createEnv</TableBodyCell>
                            <TableBodyCell>sg_Users_Azure_HSC_DevOps_SelfService_Create</TableBodyCell>
                            <TableBodyCell>For users who create environments/tenants for customers</TableBodyCell>
                        </TableBodyRow>
                        <TableBodyRow>
                            <TableBodyCell>Lock APP Environments</TableBodyCell>
                            <TableBodyCell>lockAppEnv</TableBodyCell>
                            <TableBodyCell>sg_Users_Azure_HSC_DevOps_SelfService_Privilege</TableBodyCell>
                            <TableBodyCell>For users who delete APP customer environments/tenants</TableBodyCell>
                        </TableBodyRow>
                        <TableBodyRow>
                            <TableBodyCell>Soft Delete ACPP Organisations</TableBodyCell>
                            <TableBodyCell>softDeleteAcppEnv</TableBodyCell>
                            <TableBodyCell>sg_Users_Azure_HSC_DevOps_SelfService_Privilege</TableBodyCell>
                            <TableBodyCell>For users who delete ACPP organisations</TableBodyCell>
                        </TableBodyRow>
                        <TableBodyRow>
                            <TableBodyCell>Configure ACR</TableBodyCell>
                            <TableBodyCell>configureACR</TableBodyCell>
                            <TableBodyCell>sg_Users_Azure_HSC_DevOps_SelfService_ACR_Configuration</TableBodyCell>
                            <TableBodyCell>Can disable People Planner and enable Care Rostering</TableBodyCell>
                        </TableBodyRow>
                        <TableBodyRow>
                            <TableBodyCell>Enable ACR</TableBodyCell>
                            <TableBodyCell>enableACR</TableBodyCell>
                            <TableBodyCell>sg_Users_Azure_HSC_Devops_SelfService_ACR_Enable</TableBodyCell>
                            <TableBodyCell>Can enable Care Rostering for customers</TableBodyCell>
                        </TableBodyRow>
                        <TableBodyRow>
                            <TableBodyCell>Configure ACC</TableBodyCell>
                            <TableBodyCell>configureACC</TableBodyCell>
                            <TableBodyCell>sg_Users_Azure_HSC_Devops_SelfService_ACC_Configuration</TableBodyCell>
                            <TableBodyCell>Can configure ACC Clients, hook up to Evo etc.</TableBodyCell>
                        </TableBodyRow>
                        <TableBodyRow>
                            <TableBodyCell>Lock ACC Environments</TableBodyCell>
                            <TableBodyCell>lockAccEnv</TableBodyCell>
                            <TableBodyCell>sg_Users_Azure_HSC_DevOps_SelfService_Privilege</TableBodyCell>
                            <TableBodyCell>Can lock ACC sites for termination</TableBodyCell>
                        </TableBodyRow>
                        <TableBodyRow>
                            <TableBodyCell>Configure ACPP</TableBodyCell>
                            <TableBodyCell>configureACPP</TableBodyCell>
                            <TableBodyCell>sg_Users_Azure_HSC_Devops_SelfService_ACPP_Configuration</TableBodyCell>
                            <TableBodyCell>Can configure policy types & other workspace tasks for customers for ACPP</TableBodyCell>
                        </TableBodyRow>
                        <TableBodyRow>
                            <TableBodyCell>Access Telemetry Data</TableBodyCell>
                            <TableBodyCell>accessTelemetryData</TableBodyCell>
                            <TableBodyCell>sg_Users_Azure_HSC_DevOps_SelfService_Telemetry</TableBodyCell>
                            <TableBodyCell>Can view and generate usage telemetry reports for ACC and ACPP</TableBodyCell>
                        </TableBodyRow>
                        <TableBodyRow>
                            <TableBodyCell>APP Reactive Support</TableBodyCell>
                            <TableBodyCell>appReactiveSupport</TableBodyCell>
                            <TableBodyCell>sg_Users_Azure_HSC_Devops_SelfService_ACR_Reactive</TableBodyCell>
                            <TableBodyCell>Can perform Restore Live to Test for APP customers</TableBodyCell>
                        </TableBodyRow>
                        <TableBodyRow>
                            <TableBodyCell>HSC Support</TableBodyCell>
                            <TableBodyCell>hscSupport</TableBodyCell>
                            <TableBodyCell>sg_Users_Azure_HSC_Devops_SelfService_hsc_support</TableBodyCell>
                            <TableBodyCell>Can perform support-related operations</TableBodyCell>
                        </TableBodyRow>
                    </TableBody>
                </Table>
            </>
        )
    }

    const renderSelfServiceLinks = () => {
        return (
            <Table className={styles.customTable}>
                <TableHead>
                    <TableHeadRow>
                        <TableHeadCell>Environment</TableHeadCell>
                        <TableHeadCell>PeoplePlanner</TableHeadCell>
                        <TableHeadCell>Care Compliance</TableHeadCell>
                        <TableHeadCell>Policies & Procedures</TableHeadCell>
                        <TableHeadCell>URL</TableHeadCell>
                    </TableHeadRow>
                </TableHead>
                <TableBody>
                    <TableBodyRow>
                        <TableBodyCell>Production</TableBodyCell>
                        <TableBodyCell><ul><li>Production CorporateSite</li><li>ACRStaging CorporateSite</li></ul></TableBodyCell>
                        <TableBodyCell><ul><li>Prod CorpSite</li><li>Demo CorpSite</li><li>Staging CorpSite</li></ul></TableBodyCell>
                        <TableBodyCell><ul><li>Production</li><li>Demo</li><li>Staging</li></ul></TableBodyCell>
                        <TableBodyCell><a
                            href={'https://selfservice.hsc.accessacloud.com'}>https://selfservice.hsc.accessacloud.com</a>
                        </TableBodyCell>
                    </TableBodyRow>
                    <TableBodyRow>
                        <TableBodyCell>Pre-Production/Test</TableBodyCell>
                        <TableBodyCell><ul><li>Dev CorporateSite</li><li>CareConnect CorporateSite</li></ul></TableBodyCell>
                        <TableBodyCell><ul><li>pb CorpSite</li><li>qa CorpSite</li></ul></TableBodyCell>
                        <TableBodyCell><ul><li>PreProd</li><li>Dev/LoadTest</li></ul></TableBodyCell>
                        <TableBodyCell><a
                            href={'https://selfservicepreprod.hsc.accessacloud.com'}>https://selfservicepreprod.hsc.accessacloud.com</a>
                        </TableBodyCell>
                    </TableBodyRow>
                </TableBody>
            </Table>
        )
    }

    return (
        <div className={styles.infoPage}>
            <h1>Info</h1>
            <div>
                <h3>Self Service Links</h3>
                <div className={styles.tableContainer}>
                    {renderSelfServiceLinks()}
                </div>

                <h3>Roles</h3>
                {renderRolesInfo()}

                <h3>Known Bugs</h3>
                {renderKnownBugs()}
            </div>
        </div>
    );

}

export default Info;
